<template lang="pug" src="./itemsSplitter.pug"></template>
<style lang="scss" src="./itemsSplitter.scss" scoped></style>

<script>
export default {
    props: {
        title: {
            type: String,
            default: null
        },
        chosenItems: {
            type: Array,
            default: () => []
        },
        availableItems: {
            type: Array,
            default: () => []
        },
        useLocale: Boolean
    },
    methods: {
        addItem(fromArray, toArray, item) {
            const itemIndex = fromArray.findIndex(it => it.id === item.id)

            fromArray.splice(itemIndex, 1)
            toArray.unshift(item)
        },
        itemHover(event) {
            const { target: parent } = event
            const element = parent.querySelector('span')
            const button = parent.querySelector('button')

            if (!element) {
                return false
            }

            const { width: parentWidth } = this.getSize(parent)
            const { width: elementWidth } = this.getSize(element)
            const { width: buttonWidth } = this.getSize(button, true)

            if (parentWidth - buttonWidth === elementWidth) {
                element.setAttribute('title', element.textContent)
            }
        },
        getSize(element, isFullWidth) {
            const computed = window.getComputedStyle(element)

            const marginLeft = parseFloat(computed.marginLeft)
            const marginRight = parseFloat(computed.marginRight)
            const width = parseFloat(computed.width)
            const height = parseFloat(computed.height)

            const calculatedWidth = Math.round(isFullWidth ? marginLeft + marginRight + width : width)

            return {
                width: calculatedWidth,
                height
            }
        }
    }
}
</script>
